export class VisualItemInfo {
  constructor(
    public title: string,
    public action: () => void,
    public cssClass: string = '',
  ) { }
}
